module.exports = "<app-inventory-manager [inventoryManagerType]=\"'MIX'\"></app-inventory-manager>"